import { render, staticRenderFns } from "./vue-multi-select.vue?vue&type=template&id=0ea235da&scoped=true&"
import script from "./vue-multi-select.js?vue&type=script&lang=js&"
export * from "./vue-multi-select.js?vue&type=script&lang=js&"
import style0 from "./vue-multi-select.css?vue&type=style&index=0&id=0ea235da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea235da",
  null
  
)

export default component.exports